exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container__2pN_ {\n  position: absolute;\n  z-index: 1; }\n", "", {"version":3,"sources":["/app/src/ui/canvas/src/ui/canvas/FloatMenu.scss"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW,EACZ","file":"FloatMenu.scss","sourcesContent":[".container {\n  position: absolute;\n  z-index: 1;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container__2pN_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/ui/canvas/FloatMenu.scss
// module id = 833
// module chunks = 0